class PortalLink extends HTMLElement {
  connectedCallback() {
    this.style.display = 'contents';

    const destination = this.getAttribute('page-destination');
    if (!destination || destination === 'none') return;

    const link = this.querySelector('a');
    if (!link) return;

    const fallbackHref = link.href;

    link.addEventListener('click', async (event) => {
      event.preventDefault();

      try {
        const session = await recharge.auth.loginShopifyAppProxy();
        const portalAccess = await recharge.customer.getCustomerPortalAccess(session, {
          page_destination: destination,
        });

        window.location.href = portalAccess?.portal_url || fallbackHref;
      } catch (error) {
        console.error('portal-link:', error);
        window.location.href = fallbackHref;
      }
    });
  }
}

customElements.define('portal-link', PortalLink);
